import React from 'react';
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';

import { useGetRegions } from 'modules/global';

import { IUserData } from '..';

import styles from '../auth-modal.module.scss';

interface IProps {
  data: IUserData;
  setData: React.Dispatch<React.SetStateAction<IUserData>>;
}

const RegisterStep: React.FC<IProps> = () => {
  const t = useTranslations('auth');
  const { regions, isLoading: regionsLoading } = useGetRegions({ isNotAll: true });

  return (
    <>
      <h2 className="mb-2 text-2xl font-semibold">{t('registration_title')}</h2>
      <p className="text-md mb-4 text-gray-800">{t('registration_desc')}</p>
      <Form>
        <Form.Item
          name="full_name"
          rules={[
            {
              required: true,
              message: t('first_name_validation_message')
            }
          ]}
        >
          <Input className={styles.customInput} size="large" placeholder={t('first_name_placeholder')} />
        </Form.Item>
        <Form.Item
          name="last_name"
          rules={[
            {
              required: true,
              message: t('last_name_validation_message')
            }
          ]}
        >
          <Input className={styles.customInput} size="large" placeholder={t('last_name_placeholder')} />
        </Form.Item>
        <Row gutter={10}>
          <Col span={12}>
            <Form.Item
              name="region_id"
              rules={[
                {
                  required: true,
                  message: t('region_validation_message')
                }
              ]}
            >
              <Select
                placeholder={t('region_placeholder')}
                className={`!mt-[0.4rem] ${styles.customSelect}`}
                options={regions}
                loading={regionsLoading}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="birthday"
              rules={[
                {
                  required: true,
                  message: t('birth_date_validation_message')
                }
              ]}
            >
              <DatePicker
                size="large"
                className={styles.customDatePicker}
                style={{ width: '100%' }}
                placeholder={t('birth_date_placeholder')}
                defaultPickerValue={dayjs('2005-01-01')}
                format="DD.MM.YYYY"
                disabledDate={current => current && current > dayjs().endOf('day')}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="gender"
          rules={[
            {
              required: true,
              message: t('gender_validation_message')
            }
          ]}
        >
          <Radio.Group
            className={styles.customRadioStyle}
            options={[
              { label: t('gender_male_label'), value: 'erkak' },
              { label: t('gender_female_label'), value: 'ayol' }
            ]}
          />
        </Form.Item>
        <Button
          htmlType="submit"
          className="!mt-5 !w-full !rounded-md !border-none !bg-green-500 !py-5 !text-white"
        >
          {t('kirish')}
        </Button>
      </Form>
    </>
  );
};

export default RegisterStep;
